export default __webpack_public_path__ + "static/appwheel-89be783c1989a04e0e0c7225c0824819.png";